import styled from 'styled-components'
import { devicesMax } from './../../styles/breakpoints'
import { motion } from 'framer-motion'

export const StyledForm = styled.form`
  text-align: left;
`

export const StyledPot = styled.input`
  display: none;
  opacity: 0;
`

export const ButtonBox = styled.div`
  margin-top: 1.5rem;
  text-align: right;

  @media ${devicesMax.mobile.lg} {
    text-align: center;
  }
`

export const Modal = styled(motion.div)`
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;

  width: 100%;
  height: 100%;
  padding: 0 1.5rem;

  background: rgba(0, 0, 0, 0.7);

  display: flex;
  justify-content: center;
  align-items: center;

  opacity: 0;
`

export const ModalInner = styled(motion.div)`
  background: white;
  padding: 2rem;

  width: 650px;
  max-width: 100%;
  text-align: center;
`
